import { roundPercentages as roundPercentagesShared } from '@crowdfpl/utils/percentages';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** @see @crowdfpl/utils/percentages */
export const roundPercentages = roundPercentagesShared;
